const pregnancyDiabetType = {
  Yes: 1,
  No: 2,
  NotApplicable: 3
}

export default pregnancyDiabetType;